import React from 'react';
import { FileDown } from 'lucide-react';

const ContactsTab = ({ contacts, exportCSV }) => (
  <div className="data-table">
    <div className="table-header-row">
      <h2 className="section-heading">Recent Contact Messages</h2>
      <button onClick={() => exportCSV('contacts')} className="export-btn-sm" data-testid="export-contacts-tab"><FileDown size={16} /> CSV</button>
    </div>
    {contacts.map((contact) => (
      <div key={contact.id} className="contact-card">
        <div className="contact-header">
          <h4>{contact.name}</h4>
          <span className={`contact-status ${contact.is_read ? 'read' : 'unread'}`}>{contact.is_read ? 'Read' : 'Unread'}</span>
        </div>
        <p className="contact-email">{contact.email}</p>
        <p className="contact-subject"><strong>Subject:</strong> {contact.subject}</p>
        <p className="contact-message">{contact.message}</p>
        <p className="contact-date">{new Date(contact.created_at).toLocaleString()}</p>
      </div>
    ))}
  </div>
);

export default ContactsTab;
